import { j as o } from "../../../../jsx-runtime.BREq8dyb.js";
import { createContext as n, memo as s, useContext as a } from "react";
import { ErrorBoundary as m } from "react-error-boundary";
import l from "../../../DqAlert/DqAlert.js";
const d = (r) => /* @__PURE__ */ o.jsx(l.AsFallbackComponent, { showDismiss: !0, showExpand: !0, ...r }), e = n(() => {
}), i = e.Provider, f = () => a(e), p = s(({
  children: r,
  onError: t = () => {
  }
}) => /* @__PURE__ */ o.jsx(i, { value: t, children: /* @__PURE__ */ o.jsx(m, { FallbackComponent: d, children: r }) }));
p.displayName = "ErrorHandler";
export {
  p as ErrorHandler,
  e as ErrorHandlerContext,
  i as ErrorHandlerProvider,
  p as default,
  f as useErrorHandler
};
//# sourceMappingURL=ErrorHandler.js.map
